'use strict';

/*@ngInject*/
module.exports = function (publicObjectsService, $sce) {
	return {
		scope: {
			versionId: '<'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;

			publicObjectsService.getObjectComponents(vm.versionId).then(function (res) {
				vm.objectComponents = res.data;
			});

			vm.trustedHtml = function (text) {
				return $sce.trustAsHtml(text);
			};
		},
		template: require('./components.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/object_details_directives/components.directive.js
 **/